import { useState, useEffect, useRef } from "react";
import api from "../services/api";
import { dialogs } from "../context/DialogContext";

export const MOTIVOS_FRIO = [
  { id: "sin_interes_ahora", label: "Sin interés por ahora" },
  { id: "presupuesto", label: "Presupuesto insuficiente" },
  { id: "zona", label: "Zona o tipo no encaja" },
  { id: "timing", label: "Timing / más adelante" },
  { id: "competencia", label: "Ya compró o con otra agencia" },
  { id: "no_contacta", label: "No responde tras varios intentos" },
];

export const MOTIVOS_ELIMINAR = [
  { id: "duplicado", label: "Lead duplicado" },
  { id: "datos_erroneos", label: "Datos erróneos o spam" },
  { id: "no_interesa", label: "No le interesa el servicio" },
  { id: "solicitud_cliente", label: "Pide no ser contactado (RGPD)" },
  { id: "error_captura", label: "Error de captura / prueba" },
  { id: "otro", label: "Otro (detallar abajo)" },
];

const ETAPA_LABELS = {
  leads: "Leads",
  atendidos: "Atendidos",
  visitantes: "Visitantes",
  calientes: "Calientes",
  ventas: "Ventas",
  frios: "Fríos",
  fríos: "Fríos",
};

export function ModalMoverLeadTerminal({ destino, lead, isDark, c, onClose, onExito }) {
  const [motivoCodigo, setMotivoCodigo] = useState("");
  const [motivoLibre, setMotivoLibre] = useState("");
  const [afectarCliente, setAfectarCliente] = useState(true);
  const [enviando, setEnviando] = useState(false);
  const [err, setErr] = useState("");

  const motivos = destino === "frios" ? MOTIVOS_FRIO : MOTIVOS_ELIMINAR;
  const titulo = destino === "frios" ? "Mover a Fríos" : "Mover a Eliminados";
  const subtitulo =
    destino === "frios"
      ? "El lead pasará a la lista de fríos. Podrás seguir viéndolo y editarlo."
      : "El lead pasará a Eliminados: se archivarán conversaciones, citas y tareas en el historial; no habrá acciones automáticas hasta restaurar.";

  const mensajeErrorMover = (e) => {
    const d = e?.response?.data;
    if (typeof d?.error === "string" && d.error.trim()) return d.error;
    if (typeof d?.mensaje === "string" && d.mensaje.trim()) return d.mensaje;
    if (e?.code === "ECONNABORTED") return "Tiempo de espera agotado. Reintenta; si el lead ya no está en el embudo, mira Eliminados/Fríos.";
    if (!e?.response) return "No hubo respuesta del servidor. Reintenta; si el lead ya cambió de etapa, mira Eliminados/Fríos.";
    const st = e.response.status;
    if (st) return `No se pudo completar el cambio (HTTP ${st})`;
    return "No se pudo completar el cambio";
  };

  /** Si el proxy corta la respuesta tras un commit OK, el lead ya está en destino. */
  const leadYaEnDestino = async () => {
    if (!lead?.id) return false;
    try {
      const res = await api.get(`/leads/${lead.id}`);
      const etapa = String(res.data?.data?.etapa || "").trim().toLowerCase();
      if (destino === "eliminados") return etapa === "eliminados" || etapa === "eliminado";
      if (destino === "frios") return etapa === "frios" || etapa === "fríos";
    } catch {
      /* ignore */
    }
    return false;
  };

  const confirmar = async () => {
    setErr("");
    if (!motivoCodigo && !motivoLibre.trim()) {
      setErr("Elige un motivo estándar o escribe el motivo en texto libre.");
      return;
    }
    const chip = motivos.find((m) => m.id === motivoCodigo);
    setEnviando(true);
    let ok = false;
    try {
      await api.post(
        `/leads/${lead.id}/mover-terminal`,
        {
          destino,
          motivo_codigo: chip ? chip.label : motivoCodigo || null,
          motivo_libre: motivoLibre.trim() || null,
          afectar_cliente: afectarCliente,
        },
        { timeout: 120000 }
      );
      ok = true;
    } catch (e) {
      if (await leadYaEnDestino()) {
        ok = true;
      } else {
        setErr(mensajeErrorMover(e));
      }
    } finally {
      setEnviando(false);
    }
    if (!ok) return;
    // Callback de cierre aparte: un fallo al refrescar el pipeline no debe
    // pintarse como «no se pudo mover» si el POST ya fue bien.
    try {
      onExito?.();
    } catch (cbErr) {
      console.error("[ModalMoverLeadTerminal] onExito:", cbErr);
    }
  };

  const chipMotivo = (m) => {
    const activo = motivoCodigo === m.id;
    return (
      <button
        key={m.id}
        type="button"
        onClick={() => setMotivoCodigo(activo ? "" : m.id)}
        style={{
          padding: "6px 10px",
          borderRadius: 8,
          fontSize: 11,
          fontWeight: 600,
          border: `1.5px solid ${activo ? (destino === "frios" ? "#64748b" : "#ef4444") : c.border}`,
          background: activo
            ? destino === "frios"
              ? "rgba(100,116,139,0.2)"
              : "rgba(239,68,68,0.15)"
            : c.bgInput,
          color: activo ? c.textPrimary : c.textMuted,
          cursor: "pointer",
          fontFamily: "inherit",
        }}
      >
        {m.label}
      </button>
    );
  };

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 1200,
        background: "rgba(0,0,0,0.65)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(3px)",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: 440,
          maxWidth: "94vw",
          maxHeight: "88vh",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          borderRadius: 14,
          background: isDark ? c.bgCard : "#e8e8e0",
          border: `1px solid ${isDark ? c.border : "#a8a8a0"}`,
          boxShadow: "0 24px 64px rgba(0,0,0,0.45)",
        }}
      >
        <div
          style={{
            height: 3,
            background:
              destino === "frios"
                ? "linear-gradient(90deg,#64748b,#3b82f6)"
                : "linear-gradient(90deg,#ef4444,#b91c1c)",
          }}
        />
        <div
          style={{
            padding: "14px 18px",
            borderBottom: `1px solid ${c.border}`,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: 10,
          }}
        >
          <div>
            <div style={{ fontSize: 15, fontWeight: 800, color: c.textPrimary }}>{titulo}</div>
            <div style={{ fontSize: 11, color: c.textMuted, marginTop: 4, lineHeight: 1.45 }}>
              {subtitulo}
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            style={{
              flexShrink: 0,
              width: 28,
              height: 28,
              borderRadius: 8,
              border: `1px solid ${c.border}`,
              background: c.bgInput,
              cursor: "pointer",
              color: c.textMuted,
            }}
          >
            ✕
          </button>
        </div>

        <div style={{ padding: "14px 18px", overflowY: "auto", flex: 1 }}>
          <div
            style={{
              fontSize: 10,
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: "0.08em",
              color: c.textMuted,
              marginBottom: 8,
            }}
          >
            Motivo (elige uno o varios con texto libre)
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 12 }}>
            {motivos.map(chipMotivo)}
          </div>
          <textarea
            value={motivoLibre}
            onChange={(e) => setMotivoLibre(e.target.value)}
            placeholder="Texto libre (opcional si ya marcaste un motivo estándar)"
            rows={3}
            style={{
              width: "100%",
              boxSizing: "border-box",
              padding: "8px 10px",
              borderRadius: 8,
              border: `1px solid ${c.border}`,
              background: c.bgInput,
              color: c.textPrimary,
              fontSize: 12,
              fontFamily: "inherit",
              resize: "vertical",
              minHeight: 64,
            }}
          />

          {lead?.cliente_id && (
            <div
              style={{
                marginTop: 14,
                padding: 12,
                borderRadius: 10,
                background: isDark ? "rgba(234,179,8,0.12)" : "#fffbeb",
                border: `1px solid ${isDark ? "rgba(234,179,8,0.35)" : "#fde68a"}`,
              }}
            >
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 700,
                  color: isDark ? "#fcd34d" : "#92400e",
                  marginBottom: 6,
                }}
              >
                Cliente vinculado
              </div>
              <p style={{ margin: 0, fontSize: 11, color: c.textSecondary, lineHeight: 1.5 }}>
                Este lead tiene ficha de cliente asociada. Al mover a <strong>Fríos</strong>, el
                lead y su demanda pasan a frío/cancelada; el contacto solo va a Fríos si no
                tiene otro lead activo en pipeline. Si queda otra demanda en curso, el cliente
                sigue en Activos. En <strong>Eliminados</strong>, opcionalmente puedes
                desactivar también el cliente.
              </p>
              {destino === "eliminados" && (
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    marginTop: 10,
                    cursor: "pointer",
                    fontSize: 12,
                    fontWeight: 600,
                    color: c.textPrimary,
                  }}
                >
                  <input
                    type="checkbox"
                    checked={afectarCliente}
                    onChange={(e) => setAfectarCliente(e.target.checked)}
                  />
                  Desactivar también el cliente vinculado
                </label>
              )}
            </div>
          )}

          {err && (
            <div
              style={{
                marginTop: 10,
                padding: "8px 10px",
                borderRadius: 8,
                fontSize: 12,
                background: isDark ? "#2a1215" : "#fef2f2",
                color: "#ef4444",
                border: `1px solid ${isDark ? "#5c1d1d" : "#fecaca"}`,
              }}
            >
              {err}
            </div>
          )}
        </div>

        <div
          style={{
            padding: "12px 18px 16px",
            borderTop: `1px solid ${c.border}`,
            display: "flex",
            justifyContent: "flex-end",
            gap: 8,
          }}
        >
          <button
            type="button"
            onClick={onClose}
            disabled={enviando}
            style={{
              padding: "8px 16px",
              borderRadius: 8,
              border: `1px solid ${c.border}`,
              background: c.bgInput,
              color: c.textPrimary,
              fontWeight: 600,
              cursor: enviando ? "not-allowed" : "pointer",
              fontFamily: "inherit",
              fontSize: 12,
            }}
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={confirmar}
            disabled={enviando}
            style={{
              padding: "8px 16px",
              borderRadius: 8,
              border: "none",
              fontWeight: 700,
              cursor: enviando ? "not-allowed" : "pointer",
              fontFamily: "inherit",
              fontSize: 12,
              color: "#fff",
              background: enviando
                ? c.border
                : destino === "frios"
                  ? "linear-gradient(135deg,#64748b,#3b82f6)"
                  : "linear-gradient(135deg,#ef4444,#b91c1c)",
              opacity: enviando ? 0.6 : 1,
            }}
          >
            {enviando ? "Guardando…" : "Confirmar"}
          </button>
        </div>
      </div>
    </div>
  );
}

/** Menú compacto (sin altura en layout): archivar / borrar lead del embudo. */
export default function LeadArchivoMenu({
  lead,
  isDark,
  c,
  onArchivado,
  showPermanentDelete = true,
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [modalDestino, setModalDestino] = useState(null);
  const [eliminando, setEliminando] = useState(false);
  const wrapRef = useRef(null);

  const etapa = String(lead?.etapa || "").toLowerCase();
  const puedeArchivar =
    lead?.id &&
    lead.activo !== false &&
    !["eliminados", "eliminado"].includes(etapa);

  useEffect(() => {
    if (!menuOpen) return undefined;
    const onDoc = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setMenuOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [menuOpen]);

  if (!puedeArchivar) return null;

  const etapaLabel = ETAPA_LABELS[etapa] || lead.etapa || "embudo";

  const eliminarPermanente = async () => {
    setMenuOpen(false);
    const texto =
      "Vas a ELIMINAR DEFINITIVAMENTE este lead del sistema.\n\n" +
      "• NO podrás recuperarlo desde el CRM (acción irreversible).\n" +
      "• Se borrarán tareas, citas y conversaciones Ana vinculadas al lead.\n" +
      "• El cliente vinculado, si existe, no se elimina.\n\n" +
      "¿Continuar?";
    if (!(await dialogs.confirm(texto))) return;
    if (!(await dialogs.confirm("Última confirmación: ¿borrar para siempre?"))) return;

    setEliminando(true);
    try {
      await api.post(`/leads/${lead.id}/mover-terminal`, {
        destino: "eliminados",
        motivo_codigo: "error_captura",
        motivo_libre: "Archivado antes de borrado definitivo desde ficha cliente",
        afectar_cliente: false,
      });
      await api.delete(`/leads/${lead.id}/permanente`);
      onArchivado?.("permanente");
    } catch (e) {
      await dialogs.alert(
        e.response?.data?.error || e.response?.data?.mensaje || "No se pudo eliminar el lead"
      );
    } finally {
      setEliminando(false);
    }
  };

  const abrirModal = (destino) => {
    setMenuOpen(false);
    setModalDestino(destino);
  };

  const itemStyle = {
    display: "block",
    width: "100%",
    textAlign: "left",
    padding: "8px 12px",
    border: "none",
    background: "transparent",
    color: c.textPrimary,
    fontSize: 11,
    fontWeight: 600,
    cursor: "pointer",
    fontFamily: "inherit",
  };

  return (
    <>
      <div ref={wrapRef} style={{ position: "relative", flexShrink: 0 }}>
        <button
          type="button"
          title={`Lead en ${etapaLabel}: archivar o eliminar`}
          disabled={eliminando}
          onClick={() => setMenuOpen((v) => !v)}
          style={{
            width: 22,
            height: 22,
            padding: 0,
            borderRadius: 6,
            border: `1px solid ${menuOpen ? "#ef4444" : c.border}`,
            background: menuOpen ? (isDark ? "rgba(239,68,68,0.2)" : "#fef2f2") : c.bgInput,
            color: menuOpen ? "#ef4444" : c.textMuted,
            cursor: eliminando ? "wait" : "pointer",
            fontSize: 14,
            lineHeight: 1,
            fontFamily: "inherit",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          ⋮
        </button>
        {menuOpen && (
          <div
            style={{
              position: "absolute",
              right: 0,
              top: "calc(100% + 4px)",
              zIndex: 50,
              minWidth: 168,
              borderRadius: 10,
              border: `1px solid ${c.border}`,
              background: isDark ? c.bgCard : "#fff",
              boxShadow: "0 8px 24px rgba(0,0,0,0.18)",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                padding: "6px 12px",
                fontSize: 9,
                fontWeight: 700,
                textTransform: "uppercase",
                letterSpacing: "0.06em",
                color: c.textMuted,
                borderBottom: `1px solid ${c.border}`,
              }}
            >
              Lead · {etapaLabel}
            </div>
            <button type="button" style={itemStyle} onClick={() => abrirModal("frios")}>
              ❄️ Mover a Fríos
            </button>
            <button type="button" style={itemStyle} onClick={() => abrirModal("eliminados")}>
              🗑️ Mover a Eliminados
            </button>
            {showPermanentDelete && (
              <button
                type="button"
                style={{ ...itemStyle, color: "#b91c1c", borderTop: `1px solid ${c.border}` }}
                onClick={eliminarPermanente}
              >
                ⛔ Borrar definitivo
              </button>
            )}
          </div>
        )}
      </div>

      {modalDestino && (
        <ModalMoverLeadTerminal
          destino={modalDestino}
          lead={lead}
          isDark={isDark}
          c={c}
          onClose={() => setModalDestino(null)}
          onExito={() => {
            setModalDestino(null);
            onArchivado?.(modalDestino);
          }}
        />
      )}
    </>
  );
}
